const ugr = 'Growwizo';
export default ugr;
